export default {
      id: "ic-plan-cultes-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-cultes-usage",
      toString: function () {
        return this.url;
      }
    }